const educationData = [
    {
        course: "SSLC - Secondary School Leaving Certificate",
        institute: "Kongu Engineering College",
        score: "93.6%",
        years: "2018 - 2019"
    },
    {
        course: "HSC - Higher Secondary Education",
        institute: "Erode Hindu Kalvi Nilayam, Erode",
        score: "92.76%",
        years: "2020 - 2021"
    },
    {
        course: "B. Tech - Artificial Intelligence and Data Science",
        institute: "Kongu Engineering College, Erode",
        score: "9.57 CGPA",
        years: "2021 - 2025" 
    },
    {
        course: "M.S - Robotics and Cyber-Physical Systems",
        institute: "Indian Institute of Technology Madras, Chennai",
        score: "1st Semester",
        years: "2026 - Present"
    },
]

export default educationData;
